import ArrowLeftCarousel from "~/assets/icons/ArrowLeftCarousel";
import { Group } from "~/types";

type Props = {
    options: Group[];
    currentGroupIndex: number;
    changeGroup: (index: number) => void;
    showPriceOptions?: boolean;
    currency: string;
    getCurrencyValue: (currency: string, value: string) => string,
    groupTitle: string
};

const GroupSelector = ({ options, currentGroupIndex, changeGroup, showPriceOptions, currency, getCurrencyValue, groupTitle }: Props) => {

    return (
        <div className="group-selector">
            <h3>{groupTitle}</h3>
            {options.map((g, i) => (
                <div
                    key={i}
                    className={`group-item ${i === currentGroupIndex ? "active" : ""}`}
                    onClick={() => changeGroup(i)}
                >
                    <div className="group-item__content">
                        <div className="group-item__title">
                            <button className={currentGroupIndex > 0 ? "change-group-left disabled" : "change-group-left"} onClick={(e) => { e.stopPropagation(); currentGroupIndex > 0 && changeGroup(currentGroupIndex - 1) }}>
                                <ArrowLeftCarousel width="8" height="16" />
                            </button>

                            <p>{g?.Title}</p>

                            <button className={currentGroupIndex < options.length - 1 ? "change-group-right disabled" : "change-group-right"} onClick={(e) => {
                                e.stopPropagation();
                                currentGroupIndex < options.length - 1 && changeGroup(currentGroupIndex + 1)
                            }}>
                                <ArrowLeftCarousel width="8" height="16" />
                            </button>
                        </div>
                    </div>

                    {showPriceOptions && (
                        <span className="group-item__price">
                            <b>{options[currentGroupIndex]?.Price !== null && getCurrencyValue(currency, `${options[currentGroupIndex]?.Price.To}`)} </b>
                            <del>{options[currentGroupIndex]?.OldPrice !== null && getCurrencyValue(currency, `${options[currentGroupIndex]?.OldPrice.To}`)}</del>
                        </span>
                    )}


                </div>
            ))}

        </div>
    )

};

export default GroupSelector;